const myStyle = () => ({
  mainContainer: {
    overflowX: 'hidden',
  },
});

export default myStyle;